"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
var channel_1 = require("./channel");
var Session = /** @class */ (function () {
    function Session(arr) {
        var _this = this;
        arr = arr || [];
        this.sessionChannels = arr.map(function (ch, i) {
            // Make sure ch.idx is not empty and unique in this.sessionChannels
            ch.idx = ch.idx || i;
            ch.idx = _this.uniqueIdx(_this.sessionChannels, ch.idx);
            return new channel_1.Channel(ch);
        });
    }
    // Return unique idx for given channels
    Session.prototype.uniqueIdx = function (channels, idx) {
        if (!channels) {
            return idx || 0;
        }
        // Channel idx's
        var idxs = channels.reduce(function (acc, c) {
            return (!acc.find(function (i) { return i === c.idx; }) && acc.concat(c.idx)) || acc;
        }, []);
        if (!idx || idxs.find(function (i) { return i === idx; })) {
            var newIdx_1 = channels.length;
            while (idxs.find(function (i) { return i === newIdx_1; })) {
                newIdx_1 = newIdx_1 + 1;
            }
            return newIdx_1;
        }
        return idx;
    };
    Session.prototype.createChannel = function (ch) {
        // Make sure ch.idx is unique in this.sessionChannels
        ch.idx = this.uniqueIdx(this.sessionChannels, ch.idx);
        var newChannel = new channel_1.Channel(ch);
        this.sessionChannels.push(newChannel);
        return newChannel;
    };
    Object.defineProperty(Session.prototype, "channels", {
        get: function () {
            return this.sessionChannels;
        },
        enumerable: false,
        configurable: true
    });
    Session.prototype.setTransportTempo = function (valueBpm) {
        channel_1.Channel.setTransportTempo(valueBpm);
    };
    Session.prototype.startTransport = function () {
        channel_1.Channel.startTransport();
    };
    Session.prototype.stopTransport = function (deleteEvents) {
        if (deleteEvents === void 0) { deleteEvents = true; }
        channel_1.Channel.stopTransport(deleteEvents);
    };
    // Start the clips at a specific index in all the channels
    Session.prototype.startRow = function (idx) {
        this.sessionChannels.forEach(function (ch) {
            ch.startClip(idx);
        });
    };
    Session.prototype.play = function (params) {
        var _this = this;
        var channelPatterns = params.channelPatterns;
        var clipDuration = params.clipDuration || '4:0:0';
        var clipDurationInSeconds = Tone.Time(clipDuration).toSeconds();
        var stopClips = function (clips, time) {
            clips.forEach(function (c) { return c.stop(time); });
        };
        var startClips = function (channelIdx, clipIdx, time) {
            return clipIdx === '-'
                ? []
                : _this.channels
                    .filter(function (c) { return c.idx === channelIdx; })
                    .map(function (c) { var _a; return (_a = c.clips[clipIdx]) === null || _a === void 0 ? void 0 : _a.start(time); });
        };
        channelPatterns.forEach(function (_a) {
            var channelIdx = _a.channelIdx, pattern = _a.pattern;
            var clips = [];
            var time = 0;
            var prevClipIdx = '-';
            pattern.split('').forEach(function (clipIdx) {
                if (clipIdx !== prevClipIdx && clipIdx !== '_') {
                    stopClips(clips, time);
                    clips = startClips(channelIdx, clipIdx, time);
                }
                prevClipIdx = clipIdx;
                time += clipDurationInSeconds;
            });
            stopClips(clips, time);
        });
    };
    return Session;
}());
exports.Session = Session;
